var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { createVirtualBox } from '@formily/react-schema-renderer';
import { Card } from 'antd';
import styled from 'styled-components';
export var FormBlock = createVirtualBox('block', styled(function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (React.createElement(Card, __assign({ className: className, size: "small" }, props), children));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: 10px !important;\n    &.ant-card {\n      border: none;\n      box-shadow: none;\n    }\n  "], ["\n    margin-bottom: 10px !important;\n    &.ant-card {\n      border: none;\n      box-shadow: none;\n    }\n  "]))));
export default FormBlock;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd-components/esm/form-block/index.js
// module id = 6610
// module chunks = 0